const MyProfileIcon = () => {
    return (
        <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 19.5L13.9497 21H0V15.75C0 14.0958 1.34543 12.75 3 12.75H12C13.6546 12.75 15 14.0958 15 15.75V18H13.5V15.75C13.5 14.9227 12.8269 14.25 12 14.25H3C2.17313 14.25 1.5 14.9227 1.5 15.75V19.5H15ZM1.875 5.625C1.875 2.52322 4.39822 0 7.5 0C10.6018 0 13.125 2.52322 13.125 5.625C13.125 8.72678 10.6018 11.25 7.5 11.25C4.39822 11.25 1.875 8.72678 1.875 5.625ZM3.375 5.625C3.375 7.89953 5.22585 9.75 7.5 9.75C9.77415 9.75 11.625 7.89953 11.625 5.625C11.625 3.35047 9.77415 1.5 7.5 1.5C5.22585 1.5 3.375 3.35047 3.375 5.625Z" fill="#111113" />
        </svg>


    )
}

export default MyProfileIcon